import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';
import { setupSplide } from '../../../js/global';

const moduleSelector = '.content-slider';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((module) => {
    try {
      module.querySelector('script')?.remove();

      const { data } = dJSON.parse(module.data);
      const splideElement = module.querySelector('.splide');
      const splideList = module.querySelector('.splide__list');

      if (!splideElement || !splideList || !data?.length) return;

      data.forEach((item) => {
        const slide = document.createElement('div');
        slide.className = 'splide__slide';
        slide.innerHTML = /* html */ `
          <a href="${item.link || '#'}" class="slide-link">
            <img src="${item.image || ''}" alt="" />
            <button class="btn-custom secondary">Shop Now</button>
          </a>
        `;
        splideList.appendChild(slide);
      });

      const slider = new Splide(splideElement, {
        type: 'loop',
        perPage: 5,
        perMove: 1,
        gap: 24,
        pagination: true,
        arrows: false,
        autoplay: false,
        breakpoints: {
          1200: {
            perPage: 3,
          },
          991: {
            perPage: 2,
          },
        },
      });
      setupSplide(slider);
      slider.mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
